var map = {
	"./icon-home-app-active.svg": "c5c0",
	"./icon-home-app.svg": "9298",
	"./icon-home-credit-active.svg": "502e",
	"./icon-home-credit.svg": "7eef",
	"./icon-home-email.svg": "dc1e",
	"./icon-home-notice-active.svg": "2aa9",
	"./icon-home-notice-arrow.svg": "40bf",
	"./icon-home-notice-empty-active.svg": "8d62",
	"./icon-home-notice-empty.svg": "3220",
	"./icon-home-notice.svg": "093b",
	"./icon-home-person.svg": "f1e6",
	"./icon-home-phone-active.svg": "d76e",
	"./icon-home-phone.svg": "30a0",
	"./icon-home-popup-arrow.svg": "0f8b",
	"./icon-home-popup-file.svg": "9daa",
	"./icon-home-popup-phone.svg": "94af",
	"./icon-home-terminal.svg": "9729",
	"./menu-cib.svg": "c447",
	"./menu-commonModule.svg": "a41e",
	"./menu-customerService.svg": "c306",
	"./menu-hetong.svg": "ebf2",
	"./menu-jixiao.svg": "7801",
	"./menu-mo.svg": "c910",
	"./menu-qudao.svg": "1856",
	"./menu-shezhi.svg": "f343",
	"./menu-shouquan.svg": "b67e",
	"./menu-shouquan1.svg": "1bb0",
	"./menu-tongzhi.svg": "5f1f",
	"./menu-xinxi.svg": "bfb8",
	"./menu-xitong.svg": "ad1a",
	"./menu-yiqi.svg": "d5fc",
	"./menu-yonghu.svg": "bb5f",
	"./menu-zonglan.svg": "8356"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";